<div class="flex flex-col h-screen">

  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Marcas</h1>
      </div>
      <div class="flex gap-2">
        <button (click)="createBrand()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
            Nova Marca
        </button>
      </div>
     
      
    </div>
  </div>

  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <input type="text" [(ngModel)]="searchTerm" placeholder="Buscar por nome ou código..." class="border border-gray-300 rounded px-3 py-2 text-sm" />
      <div class="text-sm text-gray-600 flex items-center">
        {{ totalRecords }} marcas(s) encontrada(s)
      </div>
    </div>
  </div>

  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="brands" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Código </th>
            <th class="text-left px-6 py-3">Descrição</th>
            <th class="text-left px-6 py-3">Ativo</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-brand let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ brand.id }} </td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ brand.description }}</td>
            <td class="px-6 py-2 font-medium">{{ brand.active ? 'Sim' : 'Não' }}</td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Ver Receitas"
                  icon="pi pi-pencil"
                  text
                  severity="secondary"
                  (click)="edit(brand)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8 text-gray-500">
              Nenhuma marca encontrada
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator">
      </p-paginator>
    </div>
  </div>
</div>

<app-modal
  [header]="'Nova Marca'" [(visible)]="formVisible">
  <ng-container *ngIf="formVisible">
    <app-create-brand [id]="brandId" (modalClosed)="closeModal()" (formSubmit)="onFormSubmit()"></app-create-brand>
  </ng-container>
</app-modal>